export default __webpack_public_path__ + "static/media/no-waifus.74ca3ce5.png";